export default "__VITE_ASSET__CI$mS7rJ__"